(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationWeight', EvaluationWeight);

    EvaluationWeight.$inject = ['$resource'];

    function EvaluationWeight ($resource) {
        var resourceUrl =  'api/evaluation-weights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-weights/by-evaluation/:id', isArray: true}
        });
    }
})();
